import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;
const listeners = new Set();

const emit = () => listeners.forEach((l) => l(cache));

export const loadClubLogos = (force = false) => {
  if (!force && (cache || pending)) return pending || Promise.resolve(cache);
  pending = api
    .get("/public/club-logos")
    .then(({ data }) => { cache = data; return data; })
    .catch(() => { cache = cache || []; return cache; })
    .finally(() => { pending = null; emit(); });
  return pending;
};

export const setClubLogos = (list) => { cache = list; emit(); };

export const useClubLogos = () => {
  const [logos, setLogos] = useState(cache || []);
  useEffect(() => {
    listeners.add(setLogos);
    loadClubLogos();
    return () => listeners.delete(setLogos);
  }, []);
  return logos;
};

export const normClub = (s) =>
  (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z0-9]/g, "");

// strip trailing team suffixes like "B 3", "A", "2"
const baseName = (s) => (s || "").replace(/(\s+([A-H]|\d{1,2}))+\s*$/i, "").trim();

export const opponentOf = (match, team) => {
  const parts = (match || "").replace(/\{#[0-9a-f]{3,8}\|([^{}]*)\}/gi, "$1").split(/\s+-\s+/);
  if (parts.length < 2) return null;
  const t = normClub(team);
  const idx = t && normClub(parts[0]).startsWith(t) ? 1 : 0;
  const raw = idx === 1 ? parts.slice(1).join(" - ") : parts.slice(0, -1).join(" - ");
  return { raw, name: baseName(raw), side: idx };
};

export const findLogo = (logos, name) => {
  const n = normClub(name);
  if (!n || !logos?.length) return null;
  return (
    logos.find((l) => normClub(l.name) === n) ||
    logos.find((l) => { const k = normClub(l.name); return k.length >= 5 && (n.startsWith(k) || k.startsWith(n)); }) ||
    null
  );
};

export const opponentsOfPoster = (data) => {
  const rows = [
    ...((data.top?.rows) || []),
    ...((data.columns || []).flatMap((c) => c.rows || [])),
    ...(data.footer || []),
  ];
  const set = new Map();
  rows.forEach((r) => {
    const o = opponentOf(r.match, data.team_name);
    if (o?.name) set.set(normClub(o.name), o.name.toUpperCase());
  });
  return [...set.values()];
};
